import type { components } from '@/schema'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { playLogsColumns } from './constants'

type AdminPlayLogItem = components['schemas']['AdminPlayLogItemResponse']

interface PlayLogsTableProps {
	data: AdminPlayLogItem[]
	total: number
	isLoading?: boolean
}

export default function PlayLogsTable({
	data,
	total,
	isLoading,
}: PlayLogsTableProps) {
	return (
		<DataTablePaginate
			columns={playLogsColumns}
			data={data}
			totalItems={total}
			isLoading={isLoading}
		/>
	)
}
